export function deferNonCriticalWork(fn) {
  if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
    window.requestIdleCallback(fn, { timeout: 2000 });
  } else {
    setTimeout(fn, 0);
  }
}

export function deferToNextFrame(fn) {
  if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
    window.requestAnimationFrame(fn);
  } else {
    setTimeout(fn, 0);
  }
}

// Yield so the click paint (heart / loader) can land before API work.
export function deferAfterPaint(fn) {
  if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
    window.requestAnimationFrame(() => {
      setTimeout(fn, 0);
    });
  } else {
    setTimeout(fn, 0);
  }
}
